export default "__VITE_ASSET__DomtR8____"